export default __webpack_public_path__ + "static/media/ic_twitter.7643ee7d.svg";